import { useEffect } from "react";
import useMicSettings from "zustand-store/mic";
import DropdownSecondary from "components/dropdown-secondary";

const SelectAudioDevice = ({ compact }) => {
  const {
    inputDevice,
    outputDevice,
    inputDevices,
    outputDevices,
    setInputDevice,
    setOutputDevice,
    setAudioDevices,
  } = useMicSettings();

  const handleSetInputDevice = (device) => setInputDevice(device.deviceId);
  const handleSetOutputDevice = (device) => setOutputDevice(device.deviceId);

  useEffect(() => {
    async function setupAudioDevices() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        stream.getTracks().forEach((track) => track.stop());
        const devices = await navigator.mediaDevices.enumerateDevices();
        setAudioDevices(devices);
      } catch (error) {
        console.error("Error setting up audio devices:", error);
      }
    }

    setupAudioDevices();

    navigator.mediaDevices.addEventListener("devicechange", setupAudioDevices);
    return () => {
      navigator.mediaDevices.removeEventListener(
        "devicechange",
        setupAudioDevices
      );
    };
  }, [setAudioDevices]);

  const labelClass = compact ? "text-[12px] font-medium text-muted mb-1" : "text-base mb-1.5";
  const sectionGap = compact ? "mb-3" : "mb-5";
  const wrapperGap = compact ? "" : "mb-4";

  return (
    <div className={wrapperGap}>
      <div className={sectionGap}>
        <p className={labelClass}>Speaker</p>

        <DropdownSecondary
          identifier="deviceId"
          options={outputDevices}
          onSelect={handleSetOutputDevice}
          className={"w-full"}
          label={outputDevice?.label || "Finding devices..."}
          compact={compact}
        />
      </div>

      <div>
        <div className="flex items-center justify-between mb-1">
          <p className={labelClass}>Microphone</p>
          {compact && (
            <span
              className={`text-[11px] font-medium px-2 py-0.5 rounded-full ${
                inputDevice
                  ? "bg-shade-50 text-accent"
                  : "bg-danger/10 text-danger"
              }`}
            >
              {inputDevice ? "Connected" : "Not connected"}
            </span>
          )}
        </div>

        <div className={compact ? "" : "flex flex-col gap-3"}>
          <DropdownSecondary
            identifier="deviceId"
            options={inputDevices}
            onSelect={handleSetInputDevice}
            className={"w-full"}
            label={inputDevice?.label || "Finding devices..."}
            compact={compact}
          />

          {!compact && (
            <div
              className={`${
                inputDevice ? "bg-shade-50" : "bg-danger/10"
              } border w-fit border-solid border-ink rounded-ns-tile text-base px-6 py-2`}
            >
              {inputDevice ? "Connected" : "Not connected"}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectAudioDevice;